<template>
    <v-container>

        <v-checkbox v-model="formActive" color="#c42111" :label="'Selected Site(s)'" @change="onChange" />
        <v-row>

            <v-col v-if="formActive">
                <v-text-field v-model="search" class="mb-2" color="#c42111" append-icon="mdi-magnify" :label="searchText" single-line hide-details :rules="[validation.required(formActive, selected)]"></v-text-field>
                <v-data-table v-model="selected" item-key="value" :headers="headers" :items-per-page="250" :items="items" :search="search" show-select class="elevation-1" @input="onChange" 
                    :class="{'no-select': shiftKeyPressed}" style="maxHeight: 400px; overflow-y: auto;" @click:row="rowClicked" @item-selected="itemSelected" :footer-props="footerProps" @current-items="searchChange">
                </v-data-table>
                <span style="color: rgba(255,255,255,0.7); font-size: 14px;">{{`shift+click to select range. ${selected.length} currently selected.`}}</span></br>
                <span style="color: #ff5252; font-size: 14px;" v-if="requiredInvalid">You must select at least one item</span>
            </v-col>

            <v-col v-if="secondaryItems.length && formActive">
                <v-autocomplete v-model="secondarySelected" :multiple="true" :items="secondaryItems" @change="onChange" :disabled="!formActive" />
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'SiteSelect',
    props: ['param'],
    data: () => ({
        formActive: false,
        selected: [],
        items: [],
        searchText: "",
        secondaryItems: [],
        secondarySelected: [],
        validation: {
            required: (formActive, selected) => (!formActive || selected.length > 0) || `You must select at least one site`
        },
        filteredItems: [],

        headers: [
            {text: 'Site', value: 'text'}
        ],
        footerProps: {
            'items-per-page-options': [50, 100, 250, 500, 100, -1]
        },
        search: '',
        shiftKeyPressed: false,
        lastSelectedIndex: null,
    }),

    computed: {
        requiredInvalid() {
            return (this.formActive && this.selected.length == 0);
        }
    },

    methods: {
        onChange: function(val) {
            let selectedValue = '';
            let humanText = '';

            if(this.formActive) {
                selectedValue = '1';
            }
            else {
                this.param.selectedValue = "0 0 0";
                this.param.humanText = "All Sites";
                return;
            }

            selectedValue += ` `;

            if(this.selected.length) {
                for(let item of this.selected) {
                    selectedValue += `${item.value};`;
                    humanText += `${item.text}, `
                }
                selectedValue = selectedValue.slice(0, -1);
            }
            else {
                selectedValue += `0`;
            }

            selectedValue += ` `;

            if(this.secondarySelected.length) {
                for(let item of this.secondarySelected) {
                    selectedValue += `${item};`;
                    humanText += `${item}, `;
                }
                selectedValue = selectedValue.slice(0, -1);
            }
            else {
                selectedValue += `0`;
            }
            
            this.param.selectedValue = selectedValue;
            this.param.humanText = humanText.slice(0, -2);

            this.$emit('edit');
        },

        buildForm: function() {
            let formArr = [[],[],[],[],[]];

            let list = this.param.rpt_param_values.slice(0);
            let inner = 0;
            for(let i = 0; i < list.length; i++) {
                let item = list[i];
                if(item !== "") {
                    formArr[inner].push(item);
                }
                else {
                    inner += 1;
                }
            }

            this.formActive = (formArr[0][0].toLowerCase() == 'true');
            for(let [idx, item] of formArr[1].entries()) {
                this.items.push({
                    text: item,
                    value: formArr[2][idx]
                })
            }
            this.searchText = formArr[3][0];
            this.secondaryItems = formArr[4];
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            const parts = this.$props.param.encodedValue.split(' ');
            if(parts[0] == '0') {
                return;
            }
            this.formActive = true;

            let arr = parts[1].split(';');
            arr.forEach(v => {
                this.items.forEach(item => {
                    if(v == item.value) {
                        this.selected.push(item);
                    }
                });
            });

            arr = parts[2].split(';');
            arr.forEach(v => {
                this.secondaryItems.forEach(item => {
                    if(v == item) {
                        this.secondarySelected.push(item);
                    }
                })
            });
        },

        searchChange: function(filteredItems) {
            this.filteredItems = filteredItems;
            this.lastSelectedIndex = null;
        },

        rowClicked: function(item) {
            let itemIndex = this.filteredItems.indexOf(item);

            if(this.selected.includes(item)) {
                this.selected.splice(this.selected.indexOf(item), 1);
            }
            else {
                if(this.shiftKeyPressed && this.lastSelectedIndex !== null) {
                    let range = itemIndex > this.lastSelectedIndex ? this.filteredItems.slice(this.lastSelectedIndex, itemIndex + 1) : this.filteredItems.slice(itemIndex, this.lastSelectedIndex + 1);
                    for(let item of range) {
                        if(!this.selected.includes(item)) {
                            this.selected.push(item);        
                        }
                    }
                    this.lastSelectedIndex = itemIndex;
                }
                else {
                    this.selected.push(item);
                    this.lastSelectedIndex = itemIndex;
                }
            }
        },

        itemSelected: function(item) {
            this.rowClicked(item.item);
        },

        keyDownListener: function(keyEvent) {
            if(keyEvent.key.toLowerCase() == 'shift') {
                this.shiftKeyPressed = true;
            }
        },
        keyUpListener: function(keyEvent) {
            if(keyEvent.key.toLowerCase() == 'shift') {
                this.shiftKeyPressed = false;
            }
        }
    },

    mounted() {
        this.buildForm();
        this.setInputsInitialValue();
        this.onChange();

        document.addEventListener("keydown", this.keyDownListener);
        document.addEventListener ("keyup", this.keyUpListener);
    },

    destroyed() {
        document.removeEventListener("keydown", this.keyDownListener);
        document.removeEventListener("keyup", this.keyUpListener);
    }

  
};
</script>

<style scoped>

    .site-row {
        cursor: pointer;
    }

    .no-select {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }


</style>

